import './CenterContainer.css';

const CenterContainer = ({ children, inSidebar = false }) => {
	return <div className={`${inSidebar ? '' : 'fixed-center-container'}`}>{children}</div>;
};

export default CenterContainer;
